import React, { useEffect } from "react";

export const TrigerPrint = (props: any) => {
  const {
    print,
    printAgain,
    printFunc,
    printAgainFunc,
    printItemList,
    printItemListFunch,
  } = props;
  useEffect(() => {
    if (print) {
      printFunc();
    }
  }, [print]); // eslint-disable-line
  useEffect(() => {
    if (printAgain) {
      printAgainFunc();
    }
  }, [printAgain]); // eslint-disable-line
  useEffect(() => {
    if (printItemList) {
      printItemListFunch();
    }
  }, [printItemList]); // eslint-disable-line
  return <></>;
};
